import { JagoAxiosInstance } from './JagoAxiosInstance';

export function sendOTPViaEmail(data: { email: string }) {
  return JagoAxiosInstance.post('api/v2/support/otp/generate', data);
}

export function verifyOTP(data: { code: string }) {
  return JagoAxiosInstance.post('api/v2/support/otp/verify', data);
}
